
import React, { useState } from "react";
import {
  Search,
  Bell,
  Menu
} from "lucide-react";

function Header({ onMenuClick }) {
  const [search, setSearch] = useState("");

  return (
    <header className="sticky top-0 z-30 flex h-[65px] items-center justify-between border-b border-slate-200 bg-white px-4 md:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 lg:hidden"
          aria-label="Open navigation"
        >
          <Menu size={20} />
        </button>

        <div className="flex h-[38px] w-[min(265px,48vw)] items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 text-slate-400 focus-within:border-blue-300">
          <Search size={16} />

          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search..."
            className="w-full min-w-0 bg-transparent text-xs text-slate-700 outline-none placeholder:text-slate-400"
          />
        </div>
      </div>

      <div className="ml-3 flex items-center gap-3">
        <button
          type="button"
          aria-label="Notifications"
          onClick={() => alert("Notifications UI will be added later.")}
          className="relative rounded-lg bg-slate-50 p-2 text-slate-600 hover:bg-slate-100"
        >
          <Bell size={18} />
          <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-rose-500" />
        </button>

        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-pink-600 text-xs font-semibold text-white">
          S
        </div>

        <div className="hidden sm:block">
          <p className="text-[11px] font-semibold text-slate-800">
            Super Admin
          </p>
          <p className="mt-0.5 text-[9px] text-slate-400">
            Administrator
          </p>
        </div>

        
      </div>
    </header>
  );
}

export default Header;
